
import React, { useState } from 'react';
import faqs_image from '../../images/faqs_image.png'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqCustom = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faqs_section section_space pt-0">
            <div className="container">
                
                <div className='row'>
                    <div className="col-lg-12 text-center">
                        <span class="sub_heading">WHY US</span>
                        <br/>
                        <br/>
                        <div class="heading_block">
                            <h2 class="heading_text heading_top">What We Deliver</h2>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="faq_accordion accordion" id="faq_accordion">
                            <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="1">
                                        B2B Keyword Intelligence (ICP/Jobs-to-Be-Done)
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <p className='mb-0'>Map pain-killer queries, evaluation terms, and sales-assisted keywords.</p>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="2">
                                       LLM-Ready Content Engine
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <p className='mb-0'>Briefs with entities, FAQs, sources, and schema; reviewer notes for MSMEs/SMEs.</p>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="3">
                                       Programmatic Page Systems
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <p className='mb-0'>Product, use cases, industry & feature pages with automated metadata and linking.</p>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="4">
                                       Entity & Technical SEO
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <p className='mb-0'>Schema (Service/Product/FAQ), breadcrumbs, authorship, review & PR signals.</p>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="5">
                                       Digital PR & Authority
                                    </AccordionHeader>
                                    <AccordionBody accordionId="5" className='acc_body'>
                                        <p className='mb-0'>Expert quotes, analyst-friendly assets, and targeted placements to strengthen E-E-A-T.</p>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="6">
                                       AI SERP & AEO Tracking
                                    </AccordionHeader>
                                    <AccordionBody accordionId="6" className='acc_body'>
                                        <p className='mb-0'>Monitor brand mentions in AI answers; prioritize content to fill mention gaps.</p>
                                    </AccordionBody>
                                </AccordionItem>



                            </Accordion>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <img src={faqs_image} alt="faqs_image" className='img-fluid'/>
                    </div>
                </div>

                

            </div>
        </section>
    )
};
export default FaqCustom;
